import { deviceType } from '@/utils/common'
import { COMPLETED_APPLICATION, INCOMPLETE_APPLICATION } from '@/constant/application'
import PcPersonalApplication from './pc/application/index.vue'
import MobilePersonalApplication from './mobile/application/index.vue'
import ApplicationLayout from './mobile/layout/applicationLayout.vue'

const basePath = '/recruiting/personal/applications'

const personalCompleteApplicationRoute = {
  path: `${basePath}/completed`,
  component: deviceType.isPc ? PcPersonalApplication : MobilePersonalApplication,
  meta: {
    applicationStatus: COMPLETED_APPLICATION,
    titleI18nKey: 'personal.menu.completedApplication',
    employeePermission: ['COMPUTED_EMPLOYEE_CAN_APPLY_JOB']
  }
}

const personalIncompleteApplicationRoute = {
  path: `${basePath}/incomplete`,
  component: deviceType.isPc ? PcPersonalApplication : MobilePersonalApplication,
  meta: {
    applicationStatus: INCOMPLETE_APPLICATION,
    titleI18nKey: 'personal.menu.incompleteApplication',
    employeePermission: ['COMPUTED_EMPLOYEE_CAN_APPLY_JOB'],
    showBadge: 'incomplete'
  }
}

const route = [
  personalCompleteApplicationRoute,
  personalIncompleteApplicationRoute
]

export default {
  path: `${basePath}`,
  component: deviceType.isPc ? PcPersonalApplication : ApplicationLayout,
  redirect: personalCompleteApplicationRoute.path,
  meta: {
    isAllInclude: true,
    query: 'status',
    mobileHomeMenu: {
      iconClass: 'iconapplications',
      nameI18nKey: 'personal.applications.homeMenu.name',
      descI18nKey: 'personal.applications.homeMenu.desc'
    }
  },
  children: route
}

export { personalCompleteApplicationRoute, personalIncompleteApplicationRoute }
